import firebase from 'firebase'

/* Firebase configuration */
const config = {
  apiKey: "AIzaSyDjrN2ilB2YdLkhP7w88uUH7fW-h7zaWOU",
  authDomain: "neighborgood-717b7.firebaseapp.com",
  databaseURL: "https://neighborgood-717b7.firebaseio.com",
  projectId: "neighborgood-717b7",
  storageBucket: "neighborgood-717b7.appspot.com",
  messagingSenderId: "312970879219",
  appId: "1:312970879219:web:c41ca2cbae4838e672d786",
  measurementId: "G-K5DPF3HXZ2"
};

export const firebaseApp = firebase.initializeApp(config)
export const communitiesRef = firebaseApp.database().ref().child('communities')
export const adminsRef = firebaseApp.database().ref().child('admins')
export const communityXadmins = firebaseApp.database().ref().child('communityXadmins')
export const membersRef = firebaseApp.database().ref().child('members')
export const householdsRef = firebaseApp.database().ref().child('households')
export const householdXmembersRef = firebaseApp.database().ref().child('householdXmembers')
export const visitorsRef = firebaseApp.database().ref().child('visitors')
export const guestsRef = firebaseApp.database().ref().child('guests')
export const announcementsRef = firebaseApp.database().ref().child('announcements')
export const suggestionsRef = firebaseApp.database().ref().child('suggestions')
export const suggestionVotesRef = firebaseApp.database().ref().child('suggestionvotes');
export const projectsRef = firebaseApp.database().ref().child('projects');